import { axiosClient } from '../config/axios-client';
import { getVapidPublicKey } from '../constants';
import { urlBase64ToUint8Array } from '../utils/decode.utils';
import userSettingsStore from './UserSettingsStore';

const BASE_PUSH_NOTIFICATION_URL = '/push';

class PushNotificationStore {
  public enablePushNotifications = async (): Promise<boolean> => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('Push notifications are not supported');
      return false;
    }

    const registration = await navigator.serviceWorker.register(
      '/service-worker.js',
    );
    await navigator.serviceWorker.ready;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return false;
    }

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(getVapidPublicKey()),
      });
    }

    await axiosClient.post(
      `${BASE_PUSH_NOTIFICATION_URL}/subscribe`,
      subscription,
    );

    return true;
  };

  public unsubscribePushNotifications = async (): Promise<void> => {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return;

    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
      await axiosClient.delete(`${BASE_PUSH_NOTIFICATION_URL}/unsubscribe`);
    }
  };

  public updatePushSubscription = (): void => {
    if (userSettingsStore.settings.pushNotifications.enabled) {
      this.enablePushNotifications().then();
    }
  };
}

const pushNotificationStore = new PushNotificationStore();
export default pushNotificationStore;
